import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=4fb5bc53&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=js&"
export * from "./Books.vue?vue&type=script&lang=js&"
import style0 from "./Books.vue?vue&type=style&index=0&id=4fb5bc53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5bc53",
  null
  
)

export default component.exports